<i18n lang='yml' src='../i18n/RoleAbilities.yml'></i18n>
<template>
    <div>
        <fieldset class='col-sm-12'>
            <legend>{{ nalb.name }}</legend>
            <table class='table table-responsive table-condensed table-bordered'>
                <tbody>
                    <tr class='text-center'>
                        <td v-for='(ability, index) in role.abilities' v-bind:key="index">
                            <strong>{{ ability.name }}</strong>
                        </td>
                    </tr>
                    <tr class='text-center'>
                      <!-- In order to make sure that the items aren't being sent multiple times
                       we need to index the abilities and we also only want to enable the hidden fallback field when
                       permissions are not allowed in order to take care of the case where they are null as well
                       as when they are disabled. We also need to add a :value to the checkboxes as true-value and
                       false-value do not change what is submitted in the form so we need to have :value change the
                       actual submission to either 0 or 1.-->
                       <!-- If a particular nalb doesn't have any abilities associated with it that means it inherits the permissions from the container level
                            so we show some text to explain that -->
                        <span v-if='role.abilities.length == 0'>{{ $t('container_controlled', {nalb: nalb.name}) }}</span>
                        <td v-for='(ability, index) in role.abilities' v-bind:key="index">
                            <input type='hidden' :name='`${fieldName}[abilities_attributes][${index}][name]`' :value='ability.name'>
                            <input type='hidden' :name='`${fieldName}[abilities_attributes][${index}][permission]`'
                                   :value='permissions.denied' v-if="ability.permission !== permissions.allowed">
                            <label>
                                <span class='sr-only'>{{ ability.name }}</span>
                                <input :id='`permission-role-${ role.id }-${ role.abilitable }-${ ability.name }`'
                                       type='checkbox' :name='`${fieldName}[abilities_attributes][${index}][permission]`'
                                        
                                       v-model='ability.permission'
                                       v-bind:true-value='permissions.allowed'
                                       v-bind:false-value='permissions.denied'


                                       :value="permissions.allowed">
                            </label>
                            <input type='hidden' :name='`${fieldName}[abilities_attributes][${index}][abilitable]`' v-model='role.abilitable'>
                        </td>
                    </tr>
                </tbody>
            </table>
        </fieldset>
    </div>
</template>

<script>
    export default {
        name: 'role-abilities',
        props: ['locale', 'role', 'permissions', 'fieldName', 'nalbs', 'nalb'],
        data() {
          return {
            abilities: this.role.abilities,
            currentIndex: this.index
          }
        },
        mounted () {
          this.$i18n.locale = this.locale;
        },

    }
</script>
